import React, { useEffect, useState } from 'react';
import { collection, doc, getDocs, query, setDoc, where } from 'firebase/firestore';
import { useParams } from 'react-router-dom';
import { firestore } from '../../../../../config/firebase';
import { Button, Input, message } from 'antd';

export default function Index() {
    const params = useParams()
    const [enrolledCourses, setEnrolledCourses] = useState([]);
    const [quizResult, setQuizResult] = useState([]);
    const [state, setState] = useState('')
    const [questionResult, setQuestionResult] = useState([]);
    const handleCategoryChange = (e) => {
        setState(e.target.value);
      };
    const getQuizResult = async () => {
        const q = query(collection(firestore, 'quizRecord'), where('attemptedUserId', '==', params.userId), where('status', '==', "active"));
        const querySnapshot = await getDocs(q);
        const array = [];
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            array.push(data);
        });
        setQuizResult(array);
    };
    const addResult = async (question) => {
        try {
            let questionAfterResult = {
                ...question,
                result: state
            }
            await setDoc(doc(firestore, 'questionsResult', question.questionAttemptedId), questionAfterResult);
            message.success('The Result Added successfully');
        } catch (error) {
            console.error('Error adding document: ', error);
        }
    }
    const getQuestionsResult = async () => {
        const q = query(collection(firestore, 'questionsResult'), where('attemptedUserId', '==', params.userId), where('status', '==', "active"));
        const querySnapshot = await getDocs(q);
        const array = [];
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            array.push(data);
        });
        setQuestionResult(array);
    };
    const getEnrolledCourses = async () => {
        const q = query(collection(firestore, 'registeredCourses'), where('enrolledBy', '==', params.userId));
        const querySnapshot = await getDocs(q);
        const array = [];
        querySnapshot.forEach((doc) => {
            const data = doc.data();
            array.push(data);
        });
        setEnrolledCourses(array);
    };

    useEffect(() => {
        getEnrolledCourses();
        getQuizResult();
        getQuestionsResult()
    }, []);

    return (
        <>
            <div className='mt-24'>
                {/* <h1 className='text-[48px] text-center underline text-[#fffa8a] italic'>Welcome {user.fullName}</h1> */}
                {enrolledCourses.length > 0 && (
                    <div>
                        <h3 className='text-[37px] text-center text-[#fffa8a] italic mt-10'>Courses Enrolled</h3>
                        <div className="container max-w-[90%] text-[#fffa8a] px-4 mx-auto sm:px-8" style={{ background: "transparent" }}>
                            <div className="py-8">
                                <div className="px-4 py-4 -mx-4 overflow-x-auto sm:-mx-8 sm:px-8">
                                    <div className="inline-block min-w-full overflow-hidden rounded-lg shadow">
                                        <table className="min-w-full leading-normal">
                                            <thead>
                                                <tr>
                                                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                                                        Title
                                                    </th>
                                                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                                                        Price
                                                    </th>
                                                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                                                        Duration
                                                    </th>
                                                    <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                                                        Enrolled Date
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {enrolledCourses.map((rowData, index) => (
                                                    <tr key={index}>
                                                        <td className="px-5 py-5 text-sm  border-b text-left border-[#fffa8a] text-[#fffa8a]">
                                                            <div className="flex items-center">
                                                                <div>
                                                                    <p className=" whitespace-no-wrap">{rowData.courseName}</p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                                                            <p className=" whitespace-no-wrap">{rowData.coursePrice}</p>
                                                        </td>
                                                        <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                                                            <p className=" whitespace-no-wrap">{rowData.courseDuration}</p>
                                                        </td>
                                                        <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                                                            {rowData.enrolledAt}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {quizResult.length > 0 && <div>
                    <h1 className='text-[37px] text-center text-[#fffa8a] italic mt-10'>All quizes Results</h1>
                    <div className="container max-w-[90%] text-[#fffa8a] px-4 mx-auto sm:px-8" style={{ background: "transparent" }}>
                        <div className="py-8">
                            <div className="px-4 py-4 -mx-4 overflow-x-auto sm:-mx-8 sm:px-8">
                                <div className="inline-block min-w-full overflow-hidden rounded-lg shadow">
                                    <table className="min-w-full leading-normal" >
                                        <thead>
                                            <tr>
                                                <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                                                    Student Name
                                                </th>
                                                <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                                                    Time
                                                </th>
                                                <th scope="col" className="px-5 py-3 text-2xl text-left  font-bold italic  border-b border-[#fffa8a] text-[#fffa8a]">
                                                    Score
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {quizResult.map((rowData, index) => (
                                                <tr key={index}>

                                                    <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                                                        <p className=" whitespace-no-wrap">{rowData.attemptedBy}</p>
                                                    </td>
                                                    <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                                                        <p className=" whitespace-no-wrap">{rowData.attemptedTime}</p>
                                                    </td>
                                                    <td className="px-5 py-5 text-sm  border-b border-[#fffa8a] text-[#fffa8a]">
                                                        {rowData.correctQuestions}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            </div>
            {questionResult.length > 0 && (
                <div>
                    <h3 className='text-[37px] text-center text-[#fffa8a] italic mt-10'>Quesrions Answers</h3>
                    {questionResult.map((question, index) => (
                        <div key={index} className="container max-w-[90%] text-[#fffa8a] px-4 mx-auto sm:px-8" style={{ background: "transparent" }}>
                            <h3 className='text-[30px] text-center text-[#fffa8a] italic mt-10'>Question Attempted at = {question.attemptedTime} </h3>
                            <h3 className='text-[20px] text-center text-[#fffa8a] italic mt-5'>Result = {question.result} </h3>
                            <h3 className='text-[20px] text-center mx-auto text-[#fffa8a] italic mt-5'>
                                <Input
                                    name='result'
                                    className='mx-auto w-72 border-[#fffa8a]  bg-transparent text-[#fffa8a]'
                                    onChange={handleCategoryChange} 
                                />
                            </h3>
                            <div className='flex justify-content-center'>
                                <Button
                                    className="px-10 mt-4 text-center rounded-2xl mx-auto hover:rounded-lg"
                                    onClick={() => addResult(question)}
                                    style={{ background: "transparent", border: "1px solid #fffa8a", color: "#fffa8a" }}
                                >
                                    Add Marks
                                </Button>
                            </div>

                            <div className="py-8">
                                <div className="px-4 py-4 -mx-4 overflow-x-auto sm:-mx-8 sm:px-8">
                                    <div className="inline-block min-w-full overflow-hidden rounded-lg shadow">
                                        <table className="min-w-full leading-normal">
                                            <thead>
                                                <tr>
                                                    <th scope="col" className="px-5 py-3 text-2xl text-left font-bold italic border-b border-[#fffa8a] text-[#fffa8a]">
                                                        Question
                                                    </th>
                                                    <th scope="col" className="px-5 py-3 text-2xl text-left font-bold italic border-b border-[#fffa8a] text-[#fffa8a]">
                                                        Answer
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {question.answers.map((rowData, innerIndex) => (
                                                    <tr key={innerIndex}>
                                                        <td className="px-5 py-5 text-sm border-b text-left border-[#fffa8a] text-[#fffa8a]">
                                                            <div className="flex items-center">
                                                                <div>
                                                                    <p className="whitespace-no-wrap">{rowData.name}</p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="px-5 py-5 text-sm border-b border-[#fffa8a] text-[#fffa8a]">
                                                            <p className="whitespace-no-wrap">{rowData.value}</p>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}



                </div>

            )}
        </>
    );
}
